import styled from "styled-components";

export const CreateBtn = styled.div`
  width: 80px;
  height: 32px;
  background: #ff7600;
  border-radius: 100px 0 0 100px;
  background-color: rgba(255, 118, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CreateBtnImg = styled.img`
  width: 24px;
  height: 24px;
`;

export const CreateBtnText = styled.span`
  color: #333333;
  font-size: 12px;
  margin-left: 8px;
  line-height: 32px;
`;
